import { useQuery } from '@tanstack/react-query';

import { BaseError } from 'helpers/BaseError';

import { VariantWithLabel } from 'models/variant.model';

import API from '../../services/api';

import alternateKeys from '../alternates/_queryKeys';

const getVariants = async (
    componentId: string,
): Promise<VariantWithLabel[]> => {
    const { data } = await API.fetchVariantsByComponentId(componentId);
    return data;
};

export default function useVariantsByComponentIdQuery(componentId: string) {
    return useQuery<VariantWithLabel[], BaseError>({
        queryKey: alternateKeys.getVariantsByComponentId(componentId),
        queryFn: () => getVariants(componentId),
        enabled: !!componentId,
        staleTime: 2 * 60 * 60 * 1000,
    });
}
